import { render, staticRenderFns } from "./CampaignPopup.vue?vue&type=template&id=bcfeffae&scoped=true"
import script from "./CampaignPopup.vue?vue&type=script&lang=js"
export * from "./CampaignPopup.vue?vue&type=script&lang=js"
import style0 from "./CampaignPopup.vue?vue&type=style&index=0&id=bcfeffae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfeffae",
  null
  
)

export default component.exports